import React, { useEffect, useState } from 'react';
import { launch } from '../mock/data';

const getTarget = () => {
  const now = new Date();
  let t = new Date(now.getFullYear(), launch.month, launch.day, launch.hour, launch.minute, 0);
  if (t.getTime() <= now.getTime()) {
    t = new Date(now.getFullYear() + 1, launch.month, launch.day, launch.hour, launch.minute, 0);
  }
  return t;
};

export const useCountdown = () => {
  const [target] = useState(getTarget);
  const [parts, setParts] = useState({ d: 0, h: 0, m: 0, s: 0, done: false });

  useEffect(() => {
    const tick = () => {
      const diff = target.getTime() - Date.now();
      if (diff <= 0) {
        setParts({ d: 0, h: 0, m: 0, s: 0, done: true });
        return;
      }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setParts({ d, h, m, s, done: false });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [target]);

  return parts;
};

const pad = (n) => String(n).padStart(2, '0');

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center">
    <span className="font-display text-[clamp(1.9rem,4.5vw,3rem)] leading-none text-[var(--ink)] tabular-nums">
      {pad(value)}
    </span>
    <span className="mt-1.5 text-[10px] uppercase tracking-[0.18em] text-[var(--muted)]">{label}</span>
  </div>
);

const Sep = () => (
  <span className="font-display text-[clamp(1.6rem,4vw,2.6rem)] leading-none text-[var(--line-strong)] -mt-2">:</span>
);

const Countdown = ({ className = '', compact = false }) => {
  const { d, h, m, s, done } = useCountdown();

  if (done) {
    return (
      <div className={`text-[var(--accent)] font-display uppercase ${compact ? 'text-sm' : 'text-xl'} tracking-wide ${className}`}>
        {compact ? 'Bundle is live' : 'The Lotus Bundle is live'}
      </div>
    );
  }

  if (compact) {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <span className="text-[10px] uppercase tracking-[0.16em] text-[var(--muted)]">Drops in</span>
        <span className="font-display text-[15px] leading-none text-[var(--ink)] tabular-nums tracking-wide">
          {pad(d)}d {pad(h)}h {pad(m)}m {pad(s)}s
        </span>
      </div>
    );
  }

  return (
    <div className={`flex items-start gap-3 sm:gap-5 ${className}`}>
      <Unit value={d} label="Days" />
      <Sep />
      <Unit value={h} label="Hours" />
      <Sep />
      <Unit value={m} label="Minutes" />
      <Sep />
      <Unit value={s} label="Seconds" />
    </div>
  );
};

export default Countdown;
